import { get } from "lodash";

const styles = ({ fontSize, typography }) => ({
  subTitleContainer: {
    display: 'inline-block',
    padding: '0 10px',
    position: 'relative',
    verticalAlign: 'middle',
    fontFamily: get(typography, 'bodyText'),
    fontSize: get(fontSize, 'bodyText'),
   },
  subTitleUl: {
    margin: '6px 0px',
    paddingLeft: '5px',
  },
});

export default styles;
